import React from 'react'
import Icons from './styles/assets/Icons.svg'

const Icon = ({ name, color, size, strokeColor, strokeWidth }) => (
  <div className="icon-wrapper-glob" style={{width: size+'px', height: size+'px'}}>
    <svg className={`icon icon-${name}`} strokeWidth={strokeWidth} stroke={strokeColor} fill={color} width={size} height={size}>
      <use xlinkHref={`${Icons}#icon-${name}`} />
    </svg>
  </div>
)

export default Icon


// WEBPACK FOOTER //
// ./src/components/Icon.js